import * as types from './types';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import state from './state';

export default { namespaced: true, types, state, getters, actions, mutations };
